const abbreviationFormatter = (num: number, digits?: number) => {
  const lookup = [
    { value: 1, symbol: 'Bytes' },
    { value: 1e3, symbol: 'KB' },
    { value: 1e6, symbol: 'MB' },
    { value: 1e9, symbol: 'GB' },
    { value: 1e12, symbol: 'TB' },
    { value: 1e15, symbol: 'PB' },
    { value: 1e18, symbol: 'EB' },
  ];
  const item = lookup
    .slice()
    .reverse()
    .find((obj) => num >= obj.value);
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  return item
    ? (num / item.value).toFixed(digits).replace(rx, '$1') + ' ' + item.symbol
    : '0';
};

export const formatFileSize = (num: number, digits?: number) => {
  if (num == null) return '';
  if (num === 0) return '0 Bytes';
  let pre = '';
  if (num < 0) {
    pre = '-';
  }
  return `${pre}${abbreviationFormatter(Math.abs(num), digits)}`;
};
